import React, { useEffect } from 'react';
import './QrScannerUi.css';
import { IonIcon } from '@ionic/react';
import { close, flashlight, imagesOutline } from 'ionicons/icons';
import { Torch } from '@capawesome/capacitor-torch';
import Loading from '../Loading/Loading';
import { useTranslate } from '../../hooks/context/useTranslate';

interface QrScannerUiProps {
  onClose: () => void;
  loadFromGallery: () => void;
  isFlashlightAvailable: boolean;
  isFileLoading: boolean;
}

const QrScannerUi: React.FC<QrScannerUiProps> = ({
  onClose,
  loadFromGallery,
  isFlashlightAvailable,
  isFileLoading,
}) => {
  const { t } = useTranslate();

  const toggleTorch = async () => {
    await Torch.toggle();
  };

  useEffect(() => {
    const handleBackButton = (ev) => {
      ev.detail.register(10, () => {
        onClose();
      });
    };
    document.addEventListener('ionBackButton', handleBackButton);
    return () => {
      document.removeEventListener('ionBackButton', handleBackButton);
    };
  }, [onClose]);

  return (
    <div className="barcode-scanner-modal">
      {isFileLoading ? (
        <Loading message={t('loadingQR')} />
      ) : (
        <div className="square"></div>
      )}
      <IonIcon className="closeIcon" icon={close} onClick={onClose} />
      {isFlashlightAvailable && (
        <IonIcon
          className="flashlightIcon"
          icon={flashlight}
          onClick={toggleTorch}
        />
      )}
      <IonIcon
        className="galleryIcon"
        icon={imagesOutline}
        onClick={loadFromGallery}
      />
    </div>
  );
};

export default QrScannerUi;
